import React, { FC } from 'react'
import { useFormik } from 'formik'
import { createStyles, makeStyles } from '@material-ui/core'
import { CourierParameterTypeDto } from './DTO/CourierParameterTypeDto'
import { CourierParameterDto } from './DTO/CourierParameterDto'
import { Modal } from '../../components/_EOS/Modal'
import { CourierParameterForm } from './forms/CourierParameterForm'
import { useApi } from '../../hooks/useApi'
import {  update } from './api'
import { Status } from '../../hooks/useFetchState'
import { courierParameterSchema } from './forms/Schema'



interface Props {
    id : number
    open: boolean 
    parameterTypes? : CourierParameterTypeDto[]
    courierParameter : CourierParameterDto   
    onClose: (success?: boolean) => void
}

export const CourierParameterEdit: FC<Props> = ({
    courierParameter,
    parameterTypes,
    open,
    onClose,
}) => {
    const { state, callApi } = useApi()

    const styles = useStyles()

    
    const {      
        values,
        errors,
        handleChange,
        resetForm,
        submitForm
    } = useFormik({
        enableReinitialize : true,
        initialValues: courierParameter,
        onSubmit: values => {
            sendData(values)
        },
        validateOnChange: true,
        validationSchema: courierParameterSchema
    })   
    
    const sendData = (courierParameter: CourierParameterDto) => {
        callApi(update(courierParameter))
            .then(() => {
                resetForm()
                onClose(true)
            })
    }

    const handleSuccessButton = () => {
        submitForm()
    }

    const handleClose = () => {
        resetForm()
        onClose()
    }

    return (
        <Modal
            open={open}
            title='Editar Parámetro'
            loading={state.status === Status.Loading}
            error={state.status === Status.Error ? state.error : undefined}
            cancelButton={{
                title: 'Cancelar',
                action: handleClose
            }}
            successButton={{
                title: 'Actualizar',
                action: handleSuccessButton
            }}>

            <div className={styles.container}>
                <CourierParameterForm parameterTypes={parameterTypes} values={values} errors={errors} handleChange={handleChange}/>
            </div>

        </Modal>
    )
}

const useStyles = makeStyles(
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
        },
        input: {
            marginBottom: 20,
        }
    })
)
